export enum FormField {
  name = 'name',
  ownerId = 'owner_id',
}

export interface FormState {
  [FormField.name]: string;
  [FormField.ownerId]: number;
}